<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div class="w">
        <div class="logo">
          <img src="../assets/logo.png" class="logo_img" alt />
          <div class="header_title" id="header_title">
            <div class="header_box" :style="index == activeIndex ? 'color: #1A7BFC;' : ''"
              v-for="(item,index) in managementList" :key="index" @click="handleSelect(item,index)">
              <span>{{item.name}}</span>
              <div class="appCode">
                <div class="statusBar_box" v-for="(item1,index1) in item.subList" :key="index1 + 'i'"
                  @click.stop="handlestatusBar(item,index,item1,index1)">
                  <span>{{item1.name}}</span>
                </div>
              </div>
            </div>
            <div class="tab-activation-item" :style="{
            		left: left+'px',
            		height: height+'px',
            		width: width+'px'
            	}"></div>
          </div>
        </div>
        <div class="el-dropdown">
          平台小程序
          <div class="appCode">
            <div class="statusBar_box">
              <span>SP分享平台</span>
              <div class="statusBar_img">
                <img src="../assets/wx3.jpg">
              </div>
            </div>
            <div class="statusBar_box">
              <span>码上评</span>
              <div class="statusBar_img">
                <img src="../assets/wx2.jpg">
              </div>
            </div>
            <div class="statusBar_box">
              <span>同侪互评</span>
              <div class="statusBar_img">
                <img src="../assets/wx4.jpg">
              </div>
            </div>
            <div class="statusBar_box">
              <span>实习生评价</span>
              <div class="statusBar_img">
                <img src="../assets/wx1.jpg">
              </div>
            </div>
          </div>
        </div>

        <div class="logo_yijiao" @click="gomedicine">智慧医教</div>

      </div>

    </el-header>
    <el-main>
      <router-view @getIndex="showIndex" :activeIndex="activeIndex"></router-view>
    </el-main>
    <el-footer>
      <div class="f">
        <div class="foot_box">
          <div class="footer_dls">
            <dl v-for="(item,index) in managementList" :key="index">
              <dt @click="handleSelect(item,index)">{{item.name}}</dt>
              <dd v-for="(item1,index1) in item.subList" :key="index1 + 'i'" @click="handlestatusBar(item,index,item1,index1)">
                {{item1.name}}
              </dd>
            </dl>

            <dl>
              <dt style="margin-right: 340px;">联系我们</dt>
              <dd><i class="iconfont icon-dianhua" style="margin-right: 5px;"></i>027-85559486 / 19907118698</dd>
              <dd><i class="iconfont icon-youxiang" style="margin-right: 5px;"></i>md_sorin@163.com</dd>
              <dd><i class="iconfont icon-daohangdizhi" style="margin-right: 5px;"></i>武汉市硚口区古田四路45-2同心健康产业园1319室</dd>
            </dl>

          </div>
          <div class="foot_img">
            <img src="https://file.zhihuiyijiao.com/ekg/ekg_prod.png">
          </div>
        </div>
        <div class="foot_box_di" style="cursor:pointer" ><a href="https://beian.miit.gov.cn/"  target="_blank" style="color:#fff">鄂ICP备2020016785号-2&emsp;&emsp;2022武汉创智空间科技有限公司版权所有</a></div>
        <!-- <div class="foot_box_di" style="cursor:pointer" @click="golink">鄂ICP备2020016785号-2&emsp;&emsp;2022武汉创智空间科技有限公司版权所有</div> -->
      </div>
    </el-footer>
  </el-container>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        activeIndex: 0,

        managementList: [{
            name: '通知资讯',
            path: '/index',
            subList: [{
                name: '新闻资讯',
                path: '/News',
                place: 0
              },
              {
                name: '活动通知',
                path: '/News',
                place: 1
              },
              {
                name: '学术指导',
                path: '/News',
                place: 2
              }
            ]
          },
          {
            name: '关于我们',
            path: '/About',
            subList: [{
                name: '专家团队',
                path: '/About',
                place: 1
              },
              {
                name: 'SP教学中心',
                path: '/About',
                place: 2
              },
              {
                name: '联系我们',
                path: '/About',
                place: 3,
                contactus: true
              }
            ]
          },
          {
            name: '互助平台',
            path: '/spInformation',
            subList: [{
                name: 'SP人才库',
                path: '/spInformation',
                place: 0
              },
              {
                name: 'SP师资库',
                path: '/spInformation',
                place: 1
              },
              {
                name: 'SP案例库',
                path: '/spInformation',
                place: 2
              },
              {
                name: 'SP教材库',
                path: '/spInformation',
                place: 3
              },
              {
                name: 'SP教具库',
                path: '/spInformation',
                place: 4
              },
              {
                name: 'SP预约',
                path: '/spInformation',
                place: 5
              }
            ]
          },
          {
            name: '证书查询',
            path: '/certificate',
            subList: [{
                name: '师资证书',
                path: '/certificate',
                place: 0,
                teachersflag: true
              },
              {
                name: '其他证书',
                path: '/certificate',
                place: 1
              }
            ]
          },
          {
            name: '智慧医教',
            path: '/smartmedical',
            subList: [{
                name: 'SP在线',
                path: '/smartmedical',
                place: 0
              },
              {
                name: '医教方案',
                path: '/smartmedical',
                place: 1
              }
            ]
          },
          {
            name: '课程',
            path: '/course',
            subList: [{
                name: '师资培训课程',
                path: '/course',
                place: 0
              },
              {
                name: 'SP培训课程',
                path: '/course',
                place: 1
              },
              {
                name: '学生示教',
                path: '/course',
                place: 2
              }
            ]
          },
        ],
        width: 0,
        height: 4,
        current: 0,
        left: 0,

      }
    },
    watch: {
      activeIndex(newVal) {
        this.activeIndex = newVal
        this.$nextTick(() => {
          this.init()
        })
      },
    },
    mounted() {
      this.init()
    },
    created() {
      if (window.sessionStorage.getItem('activeIndex')) {
        this.activeIndex = window.sessionStorage.getItem('activeIndex')
      }
    },
    methods: {
      golink(){
        window.location.href="https://beian.miit.gov.cn/"
      },
      gomedicine() {
        window.open('https://zjh.zhihuiyijiao.com/', '_blank')
      },
      handlestatusBar(item, index, item1, index1) {
        this.activeIndex = index
        window.sessionStorage.setItem('activeIndex', this.activeIndex)
        if (item1.contactus) {
          window.scrollTo(0, 50000);
          return
        }

        if (item1.teachersflag) {
          window.open('https://cmea.org.cn/', '_blank')
          return
        }
        window.scrollTo(0, 0);
        if (this.$route.path === item1.path) {
          let query = this.$route.query
          query.place = item1.place
          this.$router.replace({
            path: '/refresh',
            query: query
          })
        } else {
          this.$router.push({
            path: item1.path,
            query: {
              place: item1.place
            }
          })
        }
      },
      showIndex(val) {
        this.activeIndex = val
      },
      init() {
        let data = document.getElementsByClassName('header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          this.width = arr[this.activeIndex]
          this.left = arr.slice(0, this.activeIndex).reduce((num, item) => {
            return num + item + 50
          }, 0)
          document.getElementById('header_title').scrollLeft = this.left - arr[this.activeIndex] / 2;
        }
      },
      change(index) {
        if (index != this.activeIndex) {
          this.activeIndex = index
          // 这里调用逻辑处理或传递给父组件
          // this.$emit('change', index)
        }
      },
      handleSelect(item, index) {
        window.scrollTo(0, 0);
        this.activeIndex = index
        window.sessionStorage.setItem('activeIndex', this.activeIndex)
        this.$router.push({
          path: item.path,
        })
      }


    }
  }
</script>

<style lang="less" scoped>
  .scroll-view {
    width: 100%;
    overflow-x: auto;
    transition: all 0.3s;
  }

  .scroll-view::-webkit-scrollbar {
    height: 0;
  }

  .footer_dls {
    display: flex;
    float: left;
  }

  .footer_dls dl {
    float: left;
    width: 100%;
    white-space: nowrap;
    margin: 0;
    padding: 0;
  }

  .footer_dls dl dt {
    font-size: 16px;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
    color: #fff;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    margin-bottom: 12px;
    margin-right: 70px;
  }

  .footer_dls dd {
    margin: 0;
    padding: 0;
    color: #999999;
    cursor: pointer;
    transition: all 0.5s ease;
    font-size: 12px;
    margin-bottom: 13px;
    width: 100%;
    white-space: nowrap;
  }

  .footer_dls dd:hover {
    color: #FFFFFF;
  }


  .tab-item {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.3s;
    cursor: pointer;
    padding: 0 50px;
    box-sizing: border-box;
    /* 兼容Safari */
    -webkit-user-select: none;
    /* 兼容IE 10+ 和 Edge */
    -ms-user-select: none;
    /* 禁止用户选中的标准语法 */
    user-select: none;
  }

  .tab-a-item {
    color: #FFFFFF;
  }

  .tab-activation-item {
    background: #1A7BFC;
    position: absolute;
    top: 76px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    border-radius: 28px;
  }

  @keyframes op {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes op1 {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 0;
    }
  }

  .foot_img {
    height: 100px;

    img {
      height: 100%;
    }
  }

  .home-container {}

  .el-menu-demo {
    background-color: #FFFFFF;
    margin: 10px;
  }

  .el-header {
    background-color: #F9FBFD;
    ;
    width: 100%;
    position: fixed;
    top: 0;
    height: 80px !important;
    z-index: 999;
    // background: #1397e9;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    align-items: center;
    color: #fff;
    // background: -moz-linear-gradient(top, #1ab6fd 0%, #1397e9 100%);
    // background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #1ab6fd), color-stop(100%, #1397e9));
    // background: -webkit-linear-gradient(top, #1ab6fd 0%, #1397e9 100%);
    // background: -o-linear-gradient(top, #1ab6fd 0%, #1397e9 100%);
    // background: -ms-linear-gradient(top, #1ab6fd 0%, #1397e9 100%);
    // background: linear-gradient(to bottom, #1ab6fd 0%, #1397e9 100%);

    .logo {

      display: flex;
      align-items: center;

      // overflow: hidden;
      .logo_img {
        width: 48px;
        margin: 0 32px;
        overflow: hidden;
      }

      /deep/ .el-submenu__title {
        display: flex;
        align-items: center;
      }

      /deep/ .el-menu-item {
        border-bottom: 0;
      }

      /deep/ .el-menu {
        border-bottom: 0;
      }
    }


    .title {
      height: 100%;
      display: flex;
      align-items: center;

      img {
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        border-radius: 50%;
        margin-right: 20px;
      }

      /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: 1rem;
        right: 1.875rem;
      }

      /deep/ .el-badge__content {
        background-color: #fc2827;
        border: none;
      }

      span {
        margin-right: 25px;
        font-size: 16px;
      }

      div {
        font-size: 16px;
        cursor: pointer;
      }
    }

    /deep/ .el-submenu__title {
      display: flex;
      align-items: center;
    }
  }

  .tongzhi {
    border-radius: 10px;
    color: #FFF;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    background-color: #fc2827
  }

  .el-aside {
    background-color: #333744;

    .el-menu {
      border-right: none;
    }
  }


  .iconfont {
    margin-right: 10px;
    font-size: 12px;
  }

  .toggle-button {
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;

  }



  .appCodestyle {
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
  }


  .el-dropdown {
    line-height: 80px;
    position: relative;
    margin-left: 100px;
    white-space: nowrap;
    color: #959595;
  }

  .el-dropdown:hover {
    .appCode {
      position: absolute;
      width: 160px;
      z-index: 999;
      background-color: #ffffff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      flex-wrap: wrap;
      padding: 6px;
      display: flex;
      color: #323438;
      font-size: 16px;
      border-radius: 4px;
    }

  }

  .appCode {
    display: none;
  }

  .w {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
  }

  .f {
    width: 1200px !important;
    margin: 0 auto;
  }


  el-footer {
    background-color: #4c4c4c;
    padding: 20px 0 70px;
  }

  .el-main {
    margin-top: 80px;
    height: 100%;
    padding: 0;
  }

  .foot_box {
    display: flex;
    font-size: 14px;
    color: #FFFFFF;
    margin-top: 50px;

  }


  .foot_box_title {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 130px;
    margin-right: 50px;
  }

  .header_title {
    margin-left: 40px;
    display: inline-block;
    display: inline-flex;
    white-space: nowrap;
    align-items: center;
    position: relative;
  }

  .header_box {
    display: inline-block;
    line-height: 80px;
    color: #959595;
    font-size: 14px;
    cursor: pointer;
    letter-spacing: 1px;
    margin-right: 50px;
    position: relative;
    z-index: 99;


  }

  .header_box:hover {
    .appCode {
      position: absolute;
      width: 160px;
      z-index: 999;
      background-color: #ffffff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      flex-wrap: wrap;
      padding: 6px;
      display: flex;
      color: #323438;
      font-size: 16px;
      border-radius: 4px;
    }

  }

  /deep/ .popper__arrow {
    display: none;
  }


  .el-popper {
    margin-top: 0 !important;
  }


  .statusBar_box {
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding-left: 10px;

  }

  .statusBar_img {
    display: none;
    position: absolute;
    top: 0;
    right: 185px;
    width: 200px;


    img {
      width: 100%;
      height: 100%;
    }
  }

  .statusBar_box:hover {
    background-color: #1A7BFC;
    color: #FFFFFF;
    border-radius: 4px;

    .statusBar_img {
      // animation: op ease-in .5s;
      display: inline-block;

      animation: op ease-in .5s;

    }
  }

  .logo_yijiao {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    background-color: #1A7BFC;
    color: #FFFFFF;
    margin-top: 16px;
    margin-left: 50px;
    font-size: 12px;
    padding: 7px 12px;
    box-sizing: border-box;
    line-height: 16px;
    cursor: pointer;
  }

  .foot_box_di {
    width: 100%;
    text-align: center;
    margin-top: 46px;
    font-size: 12px;
    color: #ffffff;
  }
</style>
